(() => {
  const initTopicArticles = (root) => {
    if (!root || root.dataset.topicInitialized === 'true') return;

    const grid = root.querySelector('[data-topic-latest-grid]');
    const button = root.querySelector('[data-topic-load-more]');
    const status = root.querySelector('[data-topic-status]');

    if (!grid || !button || !status) return;

    root.dataset.topicInitialized = 'true';
    status.setAttribute('aria-live', 'polite');

    button.addEventListener('click', async (event) => {
        if (button.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }

        event.preventDefault();

        const label = button.querySelector('[data-topic-load-more-label]');
        const defaultLabel = label ? label.textContent : '';
        const loadingLabel = root.dataset.loadingLabel || defaultLabel;
        const errorMessage = root.dataset.errorMessage || 'Unable to load more articles. Please try again.';
        const requestUrl = new URL(button.dataset.nextUrl || button.href, window.location.origin);

        requestUrl.searchParams.set('section_id', root.dataset.sectionId);
        button.setAttribute('aria-disabled', 'true');
        status.textContent = '';
        if (label) label.textContent = loadingLabel;

        try {
          const response = await fetch(requestUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`Request failed: ${response.status}`);

          const responseText = await response.text();
          const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
          const nextRoot = responseDocument.querySelector('[data-topic-articles-section]');
          const nextGrid = nextRoot && nextRoot.querySelector('[data-topic-latest-grid]');

          if (!nextRoot || !nextGrid) throw new Error('Rendered article section was not found.');

          const newCards = Array.from(nextGrid.children);
          const firstNewCard = newCards[0];
          grid.append(...newCards);

          const nextButton = nextRoot.querySelector('[data-topic-load-more]');
          if (nextButton) {
            button.dataset.nextUrl = nextButton.dataset.nextUrl || nextButton.getAttribute('href');
            button.href = button.dataset.nextUrl;
            button.removeAttribute('aria-disabled');
            if (label) label.textContent = defaultLabel;
          } else {
            button.remove();
          }

          status.textContent = root.dataset.successMessage
            ? root.dataset.successMessage.replace('[count]', String(newCards.length))
            : `${newCards.length} more articles loaded.`;

          const firstNewHeading = firstNewCard && firstNewCard.querySelector('.journal-topic-card__title-link');
          if (firstNewHeading) {
            firstNewHeading.setAttribute('tabindex', '-1');
            firstNewHeading.focus({ preventScroll: true });
            firstNewHeading.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } catch (error) {
          button.removeAttribute('aria-disabled');
          if (label) label.textContent = defaultLabel;
          status.textContent = errorMessage;
        }
      }, { capture: true });
  };

  const initWithin = (container = document) => {
    container.querySelectorAll('[data-topic-articles-section]').forEach(initTopicArticles);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin());
  } else {
    initWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
